export default "__VITE_ASSET__glcp7Xf9__"